import { orchestrator } from 'satcheljs';

import { loadCollaboratorsLocationsEnded } from 'places-explore-operations';
import { setCollaboratorLocationsServiceCallComplete } from './store';

// when we have completed a service call for a date range to help track loading & empty states
orchestrator(loadCollaboratorsLocationsEnded, key => {
    setCollaboratorLocationsServiceCallComplete(key.dateRange);
});
